import React, { useState } from "react";
import { Container, Progress } from "@chakra-ui/react";
import {
  Redirect,
  Route,
  Switch,
  useHistory,
  useRouteMatch,
} from "react-router-dom";
import { CONTAINER_W } from "../constants";
import { useRegistration } from "../context/Registration";
import Checkout from "../pages/Checkout";
import EditStudent from "../pages/EditStudent";
import RegistrationSuccess from "../pages/RegistrationSuccess";
import SelectCourse from "../pages/SelectCourse";
import SelectSession from "../pages/SelectSession";

const RegistrationFlow = () => {
  const { students, removeStudentWithId } = useRegistration();
  const [currentStep, setCurrentStep] = useState<number>(0);
  let { path } = useRouteMatch();
  const history = useHistory();

  const goTo = (subpath: string) => {
    history.push(`${path}/${subpath}`);
  };

  const goToSelectCourse = () => goTo("course");
  const goToSelectSession = () => goTo("session");
  const goToEditStudent = (index: number) => goTo(`students/${index}`);
  const goToCreateStudent = () => goTo("students/create");
  const goToCheckout = () => goTo("checkout");
  const goToSuccess = () => goTo("success");

  const TOTAL_STEPS = 4;
  const stepProps = (n: number) => ({
    onMount: () => setCurrentStep(n),
  });

  return (
    <Container w={CONTAINER_W} maxW={CONTAINER_W}>
      <Progress
        hasStripe
        value={100 * (currentStep / TOTAL_STEPS)}
        position={{ base: "absolute", md: "static" }}
        top="56px"
        left="0"
        right="0"
        h="8px"
        mb={4}
        boxShadow="inner"
        borderRadius={{ base: 0, md: "lg" }}
        sx={{
          "& > div:first-of-type": {
            transitionProperty: "width",
          },
          // "& > div:first-child": {
          //   transitionProperty: "width",
          // },
        }}
      />
      <Switch>
        <Route exact path={path}>
          <Redirect to={`${path}/course`} />
        </Route>
        <Route exact path={`${path}/course`}>
          <SelectCourse
            {...stepProps(0)}
            onContinue={goToSelectSession}
          />
        </Route>
        <Route exact path={`${path}/session`}>
          <SelectSession
            {...stepProps(1)}
            onBack={goToSelectCourse}
            onContinue={() => {
              if (students.length === 0) {
                goToCreateStudent();
              } else {
                goToCheckout();
              }
            }}
          />
        </Route>
        <Route exact path={`${path}/students/create`}>
          <EditStudent {...stepProps(2)} back={goToSelectCourse} continue={goToCheckout} />
        </Route>
        <Route exact path={`${path}/students/:id`}>
          <EditStudent {...stepProps(2)} back={goToSelectCourse} continue={goToCheckout} />
        </Route>
        <Route exact path={`${path}/checkout`}>
          <Checkout
            {...stepProps(3)}
            deleteStudent={(id) => removeStudentWithId(id)}
            editStudent={goToEditStudent}
            createStudent={goToCreateStudent}
            changeClass={goToSelectCourse}
            paymentSuccess={goToSuccess}
          />
        </Route>
        <Route exact path={`${path}/success`}>
          <RegistrationSuccess {...stepProps(4)} />
        </Route>
      </Switch>
    </Container>
  );
};

export default RegistrationFlow;
